import history from "./history";
import request from './request';
import { authenticationContext } from './authenticationContext';

const handleAuthError = ({ data, status }) => {
    const error = (typeof data === 'string') ? data : data[Object.keys(data)[0]][0];
    return Promise.reject(error);
}

export const authenticationService = {
    login: (email, password) => {
        return request({
            method: "post",
            url: "/account/login",
            data: JSON.stringify({ email, password }),
        }).then(user => {
            return authenticationContext.processLogin(user);
        },(error) => {
            return handleAuthError(error.response);
        });
      
    },
    register: (email, password, confirmPassword) => {
        return request({
            method: "post",
            url: "/account/register",
            data: JSON.stringify({ email, password, confirmPassword })
        }).then(response=> response, error => {
            return handleAuthError(error.response);
        });
    },
    logout: () => {
        authenticationContext.logout();
        history.go(0);
    },
    get currentUserValue() { return authenticationContext.currentUserValue }
};